import { portfolioCategories } from './portfolio.generated';

export { portfolioCategories };

export function getCategoryBySlug(slug) {
  return portfolioCategories.find((category) => category.slug === slug);
}
